<!-- emailPreviewHtml -->
<template>
  <div class="emailPreviewHtml">
    <div class="center_2" style="padding-top:20px">
      <el-tabs type="border-card" v-model="checkTab" v-if="tabData.length > 0">
        <el-tab-pane
          v-for="(item, index) in tabData"
          :key="index"
          :label="item.text"
          :name="String(item.id)"
        ></el-tab-pane>
      </el-tabs>
      <div class="emailPreviewHtml_content" :style="{ width: iframeWidth }">
        <el-button class="emailPreviewHtml_btn" type="primary" @click="downLoad"
          >邮件下载</el-button
        >
        <iframe
          v-if="showIframe"
          id="iframe"
          style="margin-top:20px;"
          :style="{ width: iframeWidth }"
          :src="pageUrl"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getTemplateInfoLabel,
  getTemplateHtml5InfoAndType
} from "@/api/emailPush";
import html2canvas from "html2canvas";
export default {
  name: "emailPreviewHtml",
  data() {
    return {
      tabData: [],
      height: "",
      checkTab: "",
      iframeWidth: "812px",
      showIframe: false
    };
  },
  props: {},
  components: {},
  computed: {
    pageUrl() {
      return (
        window.location.origin +
        "/das-api/vas/push/task/getTemplateHtml5InfoAndType?historyId=" +
        this.$route.query.taskId +
        "&pushHistoryTemplateId=" +
        this.$route.query.pushHistoryTemplateId +
        "&type=" +
        this.checkTab +
        "&nameSpace=" +
        window.location.hostname +
        (window.location.port ? ":" + window.location.port : "") +
        "/das-api&noRedirect=true"
      );
    }
  },
  mounted() {
    this.getTemplateInfoLabel();
  },
  methods: {
    downLoadImg() {
      let $imgBox = document.getElementById("imgBox");
      html2canvas($imgBox, {
        useCORS: true,
        allowTaint: true
      })
        .then(canvas => {
          canvas.toBlob(blob => {
            const file = new File([blob], {
              type: "image/jpeg"
            });
            // 创建一个下载链接
            const link = document.createElement("a");
            link.href = URL.createObjectURL(file);
            link.download = this.$route.query.taskName + ".jpg"; // 设置文件名
            link.click(); // 模拟点击下载链接
          }, "image/jpeg");
        })
        .catch(error => {
          console.error("Error capturing screenshot:", error);
        });
    },
    downLoad() {
      let $iframe = document.getElementById("iframe");
      var iframeDocument =
        $iframe.contentDocument || $iframe.contentWindow.document;
      console.log(iframeDocument, "downLoad");
      html2canvas(iframeDocument.body, {
        useCORS: true,
        // allowTaint: true
      })
        .then(canvas => {
          canvas.toBlob(blob => {
            const file = new File([blob], {
              type: "image/jpeg"
            });
            // 创建一个下载链接
            const link = document.createElement("a");
            link.href = URL.createObjectURL(file);
            link.download = this.$route.query.taskName + ".jpg"; // 设置文件名
            link.click(); // 模拟点击下载链接
          }, "image/jpeg");
        })
        .catch(error => {
          console.error("Error capturing screenshot:", error);
        });
    },
    xiazaiceshi() {
      let $iframe = document.getElementById("iframe");
      var iframeDocument =
        $iframe.contentDocument || $iframe.contentWindow.document;
      console.log(iframeDocument, "downLoad");
      html2canvas(iframeDocument.body, {
        useCORS: true,
        allowTaint: true
      })
        .then(canvas => {
          // 将截图转换为图片格式的URL
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          // 创建一个虚拟的下载链接
          var link = document.createElement("a");
          link.href = pageData;
          link.download = "screenshot.jpg"; // 设置下载文件名
          // 触发点击事件以下载图片
          link.click();
        })
        .catch(error => {
          console.error("Error capturing screenshot:", error);
        });
    },
    downloadIamge(imgsrc, name) {
      // 下载图片地址和图片名
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function() {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据
        let a = document.createElement("a"); // 生成一个a元素
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    removePWidthStyle(iframe) {
      try {
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        if (!doc) return;

        // 查找所有带有 style="width: 1226.5px;" 的 p 标签
        const pTags = doc.querySelectorAll('p[style*="width: 1226.5px"]');
        pTags.forEach(p => {
          // 移除 style 属性中的 width: 1226.5px
          const style = p.getAttribute('style');
          if (style) {
            // 移除 width: 1226.5px; 或 width:1226.5px; (可能有空格变化)
            const newStyle = style.replace(/width\s*:\s*1226\.5px\s*;?/gi, '').trim();
            if (newStyle) {
              p.setAttribute('style', newStyle);
            } else {
              p.removeAttribute('style');
            }
          }
        });
      } catch (e) {
        console.error('移除 p 标签宽度样式失败:', e);
      }
    },
    setIframeHeight(id) {
      let _this = this;
      try {
        var iframe = document.getElementById(id);
        if (iframe.attachEvent) {
          iframe.attachEvent("onload", function() {
            _this.removePWidthStyle(iframe);
            _this.iframeWidth =
              iframe.contentWindow.document.documentElement.scrollWidth +
              8 +
              "px";
            iframe.height =
              iframe.contentWindow.document.documentElement.scrollHeight + 20;
          });
          return;
        } else {
          iframe.onload = function() {
            _this.removePWidthStyle(iframe);
            _this.iframeWidth =
              iframe.contentDocument.body.scrollWidth + 8 + "px";
            iframe.height = iframe.contentDocument.body.scrollHeight + 20;
          };
          return;
        }
      } catch (e) {
        throw new Error("setIframeHeight Error");
      }
    },
    getTemplateHtml5InfoAndType() {
      let params = {
        historyId: this.$route.query.taskId,
        pushHistoryTemplateId: this.$route.query.pushHistoryTemplateId,
        type: this.checkTab,
        nameSpace:
          window.location.hostname +
          (window.location.port ? ":" + window.location.port : "") +
          "/das-api"
      };
      getTemplateHtml5InfoAndType(params).then(res => {
        if (res.data && !res.data.status) {
          this.showIframe = true;
          this.$nextTick(() => {
            this.setIframeHeight("iframe");
          });
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getTemplateInfoLabel() {
      let params = {
        historyId: this.$route.query.taskId,
        pushHistoryTemplateId: this.$route.query.pushHistoryTemplateId
      };
      getTemplateInfoLabel(params).then(res => {
        this.tabData = [];
        if (res.data.status === 0) {
          let data = res.data.data;
          for (let i in data) {
            let obj = {
              text: i,
              id: data[i]
            };
            this.tabData.push(obj);
          }
          if (this.tabData.length > 0) {
            this.checkTab = String(this.tabData[0].id);
          }
          this.getTemplateHtml5InfoAndType();
        }
      });
    }
  }
};
</script>

<style lang="scss">
.emailPreviewHtml {
  .el-tabs {
    width: 810px;
    margin: auto;
    .el-tabs__content {
      display: none;
    }
  }
  &_content {
    position: relative;
    margin: 0 auto;
  }
  &_btn {
    position: absolute;
    top: 182px;
    right: -100px;
  }
}
// .box {
//   width: 50px;
//   height: 50px;
//   cursor: pointer;
//   position: fixed;
//   top: 0;
//   right: 0;
//   background: #fff;
// }
</style>
